<script lang="ts">
const __DsBlock = {
	icon: 'lucide:move-horizontal',
	category: 'basic',
	hidden: true,
}
</script>
<script lang="ts" setup>
import { defineBlock } from '#layers/block-engine';

;
</script>

<template>
	<div class="min-h-0 min-w-0 flex-1" />
</template>
